import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './NoticeModal.css';

const NoticeModal = (props) => {

  return (
    <Modal show={props.noticeShow} onHide={props.handleNoticeClose} dialogClassName="notice-modal">
      <Modal.Body as="div" style={{padding: "0", width: "515px", height: "575px"}}>
        <div className="popup">
          <div className="popupbg">
            <div className="popupTit">트위터 API 서비스 정책 변경으로 인한<br/>데이터 수집 중단 안내</div>
          </div>
          <div className="popupContents">
            안녕하세요, 닐슨미디어코리아입니다.<br/><br/>
            지난 2023년 4월 30일 트위터 API 서비스 유료화 정책 발표 이후, 무료 플랜 데이터 제공이 제한되어 <strong>7월 13일부로 트위터 데이터 수집을 중단</strong>하게 되었습니다.
            이로 인해 과거 데이터 수치와의 이격이 발생할 수 있음을 알려드립니다.<br/><br/>
            부득이한 상황으로 인해 트위터 데이터 수집이 제한되어 불편을 드리게 된 점을 깊은 양해 부탁드립니다.<br/><br/>
            저희 닐슨미디어코리아는 현재 상황을 최대한 고려하여 보다 정확하고 신뢰성 있는 데이터를 제공하기 위해 노력하겠으며, 
            더 나은 서비스와 데이터 제공을 위해 끊임없는 노력을 기울일 것임을 약속드립니다.<br/><br/>
            감사합니다.
          </div>
          <div className="popupfooter">
            다시 공지창 띄우지 않음 <a onClick={props.handleNoticeOff} style={{textDecoration: "none", color: "#666666", cursor: "pointer"}}>X</a>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer style={{display:"block",float:"left", textAlign:"right"}}>
        <a className="button purple" onClick={props.handleNoticeClose}>확인</a>
        <a className="button purple" onClick={props.handleNoticeOff}>계속확인</a>
      </Modal.Footer> */}
    </Modal>

  )
}

export default React.memo(NoticeModal);